import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import Scene from '../3D/Scene';
import Godrays from '../3D/Godrays';
import { GetBy } from '../_app/cuchillo/core/Element';
import gsap, { Power2 } from 'gsap';

class ScrollItem__BlockJunk extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.junk = GetBy.class("__junk", this.item);
        this.nokia = GetBy.selector(".nokia > img", this.item)[0];
        this.beer = GetBy.selector(".beer > img", this.item)[0];

        // Configuración de flotación
        this.floatItems = [
            {
                element: this.nokia,
                x: 1.5,          // Movimiento horizontal
                y: 18,           // Movimiento vertical (principal)
                rotation: 1.5,   // Rotación
                scale: 0.006,    // Variación de escala
                speed: 0.75,     // Velocidad
                phase: Math.random() * Math.PI * 2
            },
            {
                element: this.beer,
                x: 2.5,
                y: 26,
                rotation: 2.2,
                scale: 0.008,
                speed: 0.58,
                phase: Math.random() * Math.PI * 2
            }
        ];

        this.startTime = performance.now();

        // Colocar los elementos ya en su posición inicial
        this.floatItems.forEach(item => {
            const p = item.phase;

            gsap.set(item.element, {
                x: Math.cos(p * 0.7) * item.x,
                y: Math.sin(p) * item.y,
                rotation: Math.sin(p * 0.8) * item.rotation,
                scale: 1 + Math.sin(p * 1.15) * item.scale,
                force3D: true
            });
        });

        this._call = () => this.loop();

        this.onShow = () => {
            gsap.to(this.junk, {
                opacity: 1,
                duration: 1,
                ease: Power2.easeOut
            });

            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            gsap.to(this.junk, {
                opacity: 0,
                duration: 1,
                ease: Power2.easeOut
            });

            gsap.ticker.remove(this._call);
        };

        const target = this.item.querySelector('.__godray-target');

        if (target) {
            this._godrays = new Godrays(target);
            Scene.addGodrays(this._godrays);
        }
    }

    loop() {
        const t = (performance.now() - this.startTime) * 0.001;

        this.floatItems.forEach(item => {
            const p = t * item.speed + item.phase;

            gsap.set(item.element, {
                x: Math.cos(p * 0.7) * item.x,
                y: Math.sin(p) * item.y,
                rotation: Math.sin(p * 0.8) * item.rotation,
                scale: 1 + Math.sin(p * 1.15) * item.scale,
                force3D: true
            });
        });
    }

    dispose() {
        gsap.ticker.remove(this._call);

        if (this._godrays) {
            Scene.removeGodrays(this._godrays);
            this._godrays = null;
        }

        super.dispose();
    }
}

Scroll._registerClass('BlockJunk', ScrollItem__BlockJunk);

export default ScrollItem__BlockJunk;